import axios from "axios";

export const GetAccountDetails = async (params) => {
    try {
      return await axios.get("/admin/account",{ params });
    } catch (error) {
      return error;
    }
};

export const ForgotPassword = async (payload) => {
  return await axios.post(`/admin/forgot_password`, payload);
};

export const ResetPassword = async(payload)=>{
  return await axios.post(`/admin/reset_password`, payload);
};

export const ChangePassword = (payload) => {
  return axios.put(`/admin/change_password`, payload);
};
  